import React from "react";
import { useTwitchStreamers } from "../../../hooks/useTwitchStreamers";

const Streamer = React.memo(() => {
  const selectStreamers = useTwitchStreamers();

  function handleTwitchClick() {
    window.open(
      "https://www.twitch.tv/directory/game/Frantic%20Fanfic",
      "_blank"
    );
  }

  return (
    <div
      id={"streamer-container"}
      className={"hidden self-end flex-col md:flex"}
    >
      <div
        onClick={handleTwitchClick}
        className={"self-end pl-2 pr-2 cursor-pointer bg-black text-white"}
      >
        live on <br />
        twitch:
      </div>
      {selectStreamers?.map((s) => (
        <div
          key={"ttv-" + s.display_name}
          className={"flex flex-col items-end mb-2 mt-2"}
        >
          <a
            rel="noreferrer"
            target={"_blank"}
            href={`https://twitch.tv/${s.login}`}
          >
            <img
              className={"h-16 w-16 block"}
              src={s.profile_image_url}
              alt={s.display_name}
            />
          </a>
          <span className={"bg-black text-white"}>{s.display_name}</span>
        </div>
      ))}
    </div>
  );
});

export default Streamer;
